import React from "react";
import { Card, CardContent, CardHeader } from "../../components/ui/card";
import { ArrowLeft } from "lucide-react";

export const ProcedurePageSkeleton = () => {
  return (
    <div className="space-y-4 animate-pulse">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="h-10 w-10 bg-gray-300 rounded-md"></div>
          <div>
            <div className="h-8 w-64 bg-gray-300 rounded-md"></div>
          </div>
        </div>
        <div className="flex gap-2">
          <div className="h-10 w-32 bg-gray-300 rounded-md"></div>
          <div className="h-10 w-40 bg-gray-300 rounded-md"></div>
        </div>
      </div>

      {/* Details & Stakeholders Cards */}
      <div className="grid gap-4 md:grid-cols-[1fr,2fr]">
        <Card>
          <CardHeader>
            <div className="h-6 w-3/4 bg-gray-300 rounded-md"></div>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-300 rounded-md"></div>
              <div className="h-5 w-1/2 bg-gray-300 rounded-md"></div>
            </div>
            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-300 rounded-md"></div>
              <div className="h-5 w-1/2 bg-gray-300 rounded-md"></div>
            </div>
            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-300 rounded-md"></div>
              <div className="h-5 w-1/2 bg-gray-300 rounded-md"></div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <div className="h-6 w-1/2 bg-gray-300 rounded-md"></div>
            <div className="h-4 w-3/4 bg-gray-300 rounded-md mt-2"></div>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="h-5 w-full bg-gray-300 rounded-md"></div>
            <div className="h-5 w-5/6 bg-gray-300 rounded-md"></div>
          </CardContent>
        </Card>
      </div>

      {/* Description Cards */}
      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <div className="h-6 w-1/2 bg-gray-300 rounded-md"></div>
            <div className="h-4 w-3/4 bg-gray-300 rounded-md mt-2"></div>
          </CardHeader>
          <CardContent>
            <div className="h-20 w-full bg-gray-300 rounded-md"></div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <div className="h-6 w-1/2 bg-gray-300 rounded-md"></div>
            <div className="h-4 w-3/4 bg-gray-300 rounded-md mt-2"></div>
          </CardHeader>
          <CardContent>
            <div className="h-20 w-full bg-gray-300 rounded-md"></div>
          </CardContent>
        </Card>
      </div>

      {/* Activities Table */}
      <Card>
        <CardHeader>
          <div className="h-6 w-1/3 bg-gray-300 rounded-md"></div>
          <div className="h-4 w-1/2 bg-gray-300 rounded-md mt-2"></div>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="h-8 w-full bg-gray-300 rounded-md"></div>
            <div className="h-8 w-full bg-gray-300 rounded-md"></div>
            <div className="h-8 w-full bg-gray-300 rounded-md"></div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
